import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="#d41148" width="8" height="8" viewBox="0 0 32 32" {...props}><circle className={styles["st0"] || "st0"} cx="16" cy="16" r="5.75" /></svg>);